export default __webpack_public_path__ + "static/media/log-out.11c78af1.svg";